import React, { FC } from "react"
import { graphql } from "gatsby"

import { MediaBlockFragmentFragment } from "@graphqlTypes"

import LpSection from "@components/lp/LpSection/LpSection"
import Media from "@components/lp/Media/Media"

import "./MediaBlock.scss"
import { generateConditionalClassName } from "@utils"

const MediaBlock: FC<MediaBlockFragmentFragment> = ({
  additionalMedia,
  background,
  contentful_id,
  image,
  includeBackground,
  includeMediaBoxShadow,
  marginBottom,
  playVideoInPnpPlayer,
  playVideoInline,
  text,
  title,
  useDarkMode,
  wistiaId,
}) => {
  const use2upLayout = additionalMedia && additionalMedia.length === 1;
  const use3upLayout = additionalMedia && additionalMedia.length === 2;
  return (
    <LpSection
      background={background}
      className={generateConditionalClassName({
        MediaBlock: true,
        "use-2up-layout": !!use2upLayout,
        "use-3up-layout": !!use3upLayout,
      })}
      includeBackground={includeBackground}
      marginBottom={marginBottom}
      text={text}
      title={title}
      uniqueId={contentful_id}
      useDarkMode={useDarkMode}
    >
      <div className="container">
        <div className="grid">
          <div className="column">
            <div className="media-layout">
              <Media
                {...{
                  image,
                  includeMediaBoxShadow,
                  playVideoInline,
                  playVideoInPnpPlayer,
                  wistiaId,
                }}
              />
              {additionalMedia?.map(additionalMediaItem => (
                <Media
                  {...{
                    image: additionalMediaItem,
                    includeMediaBoxShadow,
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </LpSection>
  )
}

export const MediaBlockFragment = graphql`
  fragment MediaBlockFragment on ContentfulLpMediaBlock {
    ...MediaBlockMediaFragment
    additionalMedia {
      description
      imgixImage {
        gatsbyImageData(width: 800)
      }
      title
    }
    contentful_id
    text {
      raw
    }
    title
    wistiaId
    background
    includeBackground
    marginBottom
    useDarkMode
  }
`

export default MediaBlock
